// Code review - In Progress
// Documentation - In Progress
import React from 'react'
import AutoDropDown from '../ReusableComponents/AutoCompleteDropDown'
import { mainTable } from '../css/Common'
import InputText from '../ReusableComponents/InputText'
import TextArea from '../ReusableComponents/TextArea'
import DropDown from '../ReusableComponents/DropDown'

const ModulePopup = ({ data }) => {
    return (
        <div class="w-full">
            <div class={mainTable.mainContentScreen}>
                <form class="overflow-auto p-5 lg:h-96 md:min-h-[60vh] md:max-h-[60vh] min-h-fit max-h-fit sm:min-h-fit  sm:max-h-fit">
                    <div class="grid gap-4 mb-2 md:grid-cols-2">
                        <InputText
                            inputType={"text"}
                            title="Module Name"
                            name={"moduleName"}
                            classStar={"text-red-500"}
                            maxLength={100}
                            disabled={true}
                            content={data.ModuleName}
                        />
                        <DropDown
                            name="relevance"
                            title="Relevance"
                            classStar="text-red-500"
                            selectedOption={data.Relevance}
                            options={[
                                { value: "1", label: "Applicable" },
                                { value: "2", label: "Not-Applicable" },
                            ]}
                            placeholder=""
                            tabIndex={1}
                            disabled={true}
                        />

                    </div>
                    <TextArea
                        title={"Remarks"}
                        content={data.Remarks} />
                </form>
            </div>
        </div>
    )
}

export default ModulePopup